// MyButton.js
import React from "react";
import './styles/MyButton.css';

const MyButton = ({ label, onPress, disabled = false , color="yellow"}) => {

  const colorClasses = {
    yellow: 'bg-yellow-500 hover:bg-yellow-600',
    red: 'bg-red-500 hover:bg-red-600',
    green: 'bg-green-500 hover:bg-green-600',
  };
  
  return (
    <button
      className={colorClasses[color] + ` my-3 text-white font-bold py-5 px-2 rounded  ${
        disabled ? "opacity-50 cursor-not-allowed" : "animate-pulse"
      }`}
      disabled={disabled}
      onClick={onPress}
    >
      {label}
    </button>
  );
};

export default MyButton;
